import { Clock, Mail, Phone } from "lucide-react";

/** How a passenger reaches a human at their operator — a phone number they can tap. */
export const ContactCard = ({ company, testId = "contact-card" }) => {
  if (!company) return null;
  const phone = company.contact_phone || company.phone || "";
  const email = company.contact_email || company.email || "";
  const hours = company.contact_hours || "";
  const note = company.contact_note || "";
  if (!phone && !email && !note) return null;

  return (
    <div data-testid={testId} className="rounded-xl border border-ink-600 bg-ink-800 p-6">
      <p className="font-mono text-[11px] uppercase tracking-widest text-gold">
        Reach {company.name || "us"}
      </p>
      <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-3">
        {phone && (
          <a href={`tel:${phone.replace(/[^\d+]/g, "")}`} data-testid={`${testId}-phone`}
            className="inline-flex items-center gap-2 text-base text-slate-100 transition-colors hover:text-gold">
            <Phone className="h-4 w-4 text-gold" /> {phone}
          </a>
        )}
        {email && (
          <a href={`mailto:${email}`} data-testid={`${testId}-email`}
            className="inline-flex items-center gap-2 break-all text-sm text-slate-300 transition-colors hover:text-gold">
            <Mail className="h-4 w-4 text-gold" /> {email}
          </a>
        )}
        {hours && (
          <span data-testid={`${testId}-hours`} className="inline-flex items-center gap-2 text-sm text-slate-400">
            <Clock className="h-4 w-4 text-slate-500" /> {hours}
          </span>
        )}
      </div>
      {note && <p data-testid={`${testId}-note`} className="mt-3 text-sm text-slate-400">{note}</p>}
    </div>
  );
};
